import './loadingIndicator.scss'

export const LoadingIndicator = ({ style }: any) => {
    return <div className="loading-indicator" style={style || {}}></div>
}
export const TableLoadingIndicator = () => {
    return <div className="table-loading-indicator" ></div>
}